import { useFormContext } from 'react-hook-form';
import { TextInput } from '~/components/ui/forms/text-input';
import { TinyMceInput } from '~/components/ui/forms/tinymce-input';
import type { OtherWikiFormValues } from '~/utils/modules/other-wiki';

export function OtherWikiFormFields() {
  const { register } = useFormContext<OtherWikiFormValues>();

  return (
    <div className="space-y-2">
      <TextInput {...register('title')} label="Title" required />
      <TinyMceInput {...register('text')} label="Text" required />
    </div>
  );
}
